import { motion } from "motion/react";
import React from "react";
import LoadingDonutSvg from "./LoadingIconOptions/LoadingDonutSvg";
import LoadingSpotlightLottie from "./LoadingIconOptions/LoadingSpotlightLottie";

interface LoadingProps {
  delay?: number;
  icon?: "LoadingDonutSvg" | "LoadingSpotlightLottie";
  lottieClassName?: string;
}
export default function LoadingFullScreen({
  delay,
  icon = "LoadingDonutSvg",
  lottieClassName,
}: LoadingProps) {
  let component = (
    <div className="flex h-screen w-full items-center justify-center">
      {icon === "LoadingDonutSvg" ? (
        <LoadingDonutSvg />
      ) : (
        <LoadingSpotlightLottie lottieClassName={lottieClassName} />
      )}
    </div>
  );

  if (delay)
    component = (
      <motion.div
        initial={{
          opacity: 0,
        }}
        animate={{
          opacity: 1,
        }}
        transition={{
          delay: delay / 1000,
          duration: 1,
        }}
      >
        {component};
      </motion.div>
    );

  return component;
}
